import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../utils/api';
import UserForm from './AddUserForm';
import useAuth from '../context/useAuth';

const AddUser = () => {
  const history = useHistory();
  const { role } = useAuth(); 

  // Initialize form data for a new user
  const initialFormData = {
    name: '',
    email: '',
    password: '',
    phone: '',
    role: 'member', // Default role value
    memberId: null,
    isActive: true,
    isDeleted: false,
    isOTPRequired: false,
    mustChangePassword: true
  };

  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState('');

  const handleSave = (data) => {
    setFormData(data);
  
    // API call to save the new user
    api.post('/api/add-user', data)
      .then((response) => {
        // Redirect to user management page after successful creation
        history.push('/user-management');
      })
      .catch((err) => {
        // Check if the error has a response and an error message
        if (err.response && err.response.data && err.response.data.message) {
          setError(err.response.data.message);  // Display the error message returned by the API
        } else {
          setError('Failed to add user. Please try again.');  // Fallback message if no specific error is provided
        }
      });
  };

  return (
    <div className="add-user-container">
      <h2>Add New User</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <UserForm user={formData} onSave={handleSave} currentUserRole={role}  />      
    </div>
  );
};

export default AddUser;